import { Injectable, type Signal, signal } from '@angular/core';

import type { DiagnosticPartner } from '@malou-io/package-utils';

import { PARTNER_THEME_CONFIGS, type PartnerThemeConfig } from ':shared/constants/partner-themes.constants';

@Injectable({
    providedIn: 'root',
})
export class PartnerThemeContext {
    private readonly _activeTheme = signal<PartnerThemeConfig | null>(null);
    readonly activeTheme: Signal<PartnerThemeConfig | null> = this._activeTheme.asReadonly();

    initFromPartner(partner: DiagnosticPartner | null | undefined): void {
        if (!partner) {
            this._activeTheme.set(null);
            return;
        }
        this._activeTheme.set(PARTNER_THEME_CONFIGS[partner] ?? null);
    }
}
